import { FunctionComponent } from 'react'
import { observer } from 'mobx-react-lite'
import { Text } from '@fluentui/react-text'
import { GenericList, useGenericListSettings } from '@knowmax/genericlist-core'
import { LANGUAGE_LABELRESULTCOUNT } from '../../types/language'

/** Total number of items in generic list. */
export const TotalItems: FunctionComponent<{ list: GenericList }> = observer(({ list }) => {
  const settings = useGenericListSettings()

  return (
    <Text>
      {settings.onTranslate(LANGUAGE_LABELRESULTCOUNT, { count: list.totalCount })}
    </Text>
  )
})